var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"viewport-width",rawName:"v-viewport-width",value:(_vm.resizeFlickingCamera),expression:"resizeFlickingCamera"}],staticClass:"wrapper"},[_c('Flicking',{ref:"flicking",attrs:{"options":_vm.combinedOptions}},[_vm._t("default")],2),_vm._v(" "),(_vm.arrows)?_c('span',{class:[
      'flicking-arrow-prev flicking-button is-outside is-circle',
      _vm.prevClass,
      _vm.pageCount === 1 && 'flicking-arrow-is-disabled'
    ]}):_vm._e(),_vm._v(" "),(_vm.arrows)?_c('span',{class:[
      'flicking-arrow-next flicking-button is-outside is-circle',
      _vm.nextClass,
      _vm.pageCount === 1 && 'flicking-arrow-is-disabled'
    ]}):_vm._e(),_vm._v(" "),(_vm.pagination)?_c('div',{class:['flicking-pagination', _vm.paginationClass]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }